import { useReadContracts } from 'wagmi';
import { erc20Abi } from 'viem';
import { QueryOptions } from 'utils/useQueryUtils';
import { ETH_ZERO_ADDRESS } from 'utils/constants/ethConst';

interface UseTokenBalance extends QueryOptions {
  address?: `0x${string}`;
  token: `0x${string}`;
  chainId: number;
}

type TokenBalance = {
  value: bigint;
  decimals: number;
  symbol: string;
} | null;

export const useTokenBalance = (params: UseTokenBalance) => {
  const { address, token, chainId, query } = params;

  return useReadContracts({
    query: {
      enabled:
        Boolean(address !== ETH_ZERO_ADDRESS && token && chainId) &&
        (query?.enabled ?? true),
      select: (data): TokenBalance => {
        if (!data) return null;

        const [value, decimals, symbol] = data;
        return { value, decimals, symbol };
      },
    },
    allowFailure: false,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    contracts: [
      {
        address: token,
        abi: erc20Abi,
        chainId,
        functionName: 'balanceOf',
        args: address ? [address] : undefined,
      },
      {
        address: token,
        abi: erc20Abi,
        chainId,
        functionName: 'decimals',
      },
      {
        address: token,
        abi: erc20Abi,
        chainId,
        functionName: 'symbol',
      },
    ],
  });
};
